define('modules/files/files_collection',['backbone', 'jquery', '_',
  './file_model',
  'session'
], function (Backbone, $, _, FileModel, session) {
  'use strict';
  var FilesColletion = Backbone.Collection.extend({
    model: FileModel,
    params: {
      search: null,
      order_by: 'id',
      order: 'ASC'
    },
    parse: function (response) {
      if (response.metadata) {
        this.params = _.extend(this.params, response.metadata);
      }
      return response.data;
    },
    url: function () {
      return session.get('apiUrl') + 'files?' + $.param(this.params || {});
    }
  });

  return FilesColletion;
});

